import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {BesprechungPageComponent} from './pages/besprechung-page/besprechung-page.component';

const routes: Routes = [
  {
    path: ':id/:title',
    component: BesprechungPageComponent
  },
  {
    path: ':id',
    component: BesprechungPageComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BesprechungRoutingModule {
}
